import {InjectionToken} from '@angular/core';
import {SortDirection} from '@angular/material/sort';
import {FieldUiDataObj, ReportCellObj, ReportUiDataObj} from '../../../generated/generated-core.model';
import {GridColumn} from '../../modules/mx-grid/services/grid-column';


export interface FilterForm {
    field: string;
    value: any;
}

export interface MxGeneratorService {
    getColumnsArray(columnDataArray: Array<ReportUiDataObj>,
                           customColumns?: Array<GridColumn>,
                           reportName?: string): Array<GridColumn>;
    getGridLinesArray(gridDataArray: ReportCellObj[][]): Array<any>;
    getGridLinesQueryParamsArray(gridLines: ReadonlyArray<any>, formPayload: any, columns: ReadonlyArray<GridColumn>,
                                 sortBy: string, sortDirection: SortDirection): Array<any>;

    trimAbsentInputFieldsFromQueryParams(queryParams: any, input: Array<ReportUiDataObj>): any;

    getFiltersFromGraphFormData(graphInput: ReportUiDataObj[], dynamicFields: FieldUiDataObj[], formData?: any): Array<FilterForm>;
}
export const MX_REPORT_GENERATOR_TOKEN = new InjectionToken<MxGeneratorService>('MX_REPORT_GENERATOR_TOKEN');
